import { z } from 'zod'

export const FeatureFlagsResponseSchema = z.object({
  flags: z.record(z.string(), z.boolean()),
})

export type FeatureFlagsResponse = z.infer<typeof FeatureFlagsResponseSchema>

// Type-safe feature flag names
export type FeatureFlagName =
  | 'PrdBypassRMConfirmed'
  | 'EnableAdvancedReporting'
  | 'UseBetaUI'
// Add new flags here

export const FEATURE_FLAGS = {
  PrdBypassRMConfirmed: 'PrdBypassRMConfirmed',
  EnableAdvancedReporting: 'EnableAdvancedReporting',
  UseBetaUI: 'UseBetaUI',
} as const satisfies Record<string, FeatureFlagName>
